import { useState, useEffect } from "react";
import { FaMinus, FaPaperPlane, FaPlus } from "react-icons/fa";
import Button from "../../../common/Button";
import { MenuPermissionAPI } from "../../../utlis/apiService";
import InputField from "../../../common/InputField";
import { IoMdClose } from "react-icons/io";
import { AnimatePresence, motion } from "framer-motion";
import { MdClose } from "react-icons/md";

const MenuPermissionForm = ({
  isUserData,
  isMenuIDSData,
  onCancel,
  isEditing,
  onSubmit,
  formData,
}) => {
  const [userId, setUserId] = useState(null);
  const [permissions, setPermissions] = useState([
    { menuId: null, insert: false, update: false, delete: false, view: false },
  ]);
  const [localFormData, setLocalFormData] = useState({
    userId: "",
    menuId: [],
  });

  useEffect(() => {
    if (formData?.userId) {
      setUserId(formData.userId);
      setLocalFormData((prev) => ({
        ...prev,
        userId: formData.userId,
      }));
      setPermissions(
        formData.permissions?.length
          ? formData.permissions
          : [
              {
                menuId: null,
                insert: false,
                update: false,
                delete: false,
                view: false,
              },
            ],
      );
    }
  }, [formData]);

  const handleChange = (index, field, value) => {
    const updated = [...permissions];
    updated[index][field] = value;
    setPermissions(updated);
  };

  const handleAddRow = () => {
    setPermissions([
      ...permissions,
      {
        menuId: null,
        insert: false,
        update: false,
        delete: false,
        view: false,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const item = permissions[index];
    if (userId && item.menuId) {
      MenuPermissionAPI.deleteMenuId(userId, item.menuId).then(() => {
        const updated = [...permissions];
        updated.splice(index, 1);
        setPermissions(updated);
      });
    } else {
      const updated = [...permissions];
      updated.splice(index, 1);
      setPermissions(updated);
    }
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center p-2 sm:p-4 z-9999">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
            duration: 0.5,
          }}
          className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto"
        >
          <div className="bg-primary text-white flex justify-between items-center p-4 sm:p-4">
            <h2 className="text-xl font-semibold uppercase">
              {isEditing ? " Update Menu Permission" : " Set Menu Permission"}
            </h2>
            <Button
              onClick={onCancel}
              icon={MdClose}
              className="text-3xl "
            ></Button>
          </div>
          <div className="p-4 sm:p-4">
            <InputField
              type="select"
              label="User Name"
              options={isUserData}
              value={localFormData.userId}
              onChange={(selectedValue) => {
                setLocalFormData((prev) => ({
                  ...prev,
                  userId: selectedValue,
                }));
              }}
              required
            />

            <table className="table-auto w-full text-sm border border-gray-300 mt-6">
              <thead className="bg-gray">
                <tr className="text-center">
                  <th className="border px-2">Menu</th>
                  <th className="border px-2">Insert</th>
                  <th className="border px-2">Update</th>
                  <th className="border px-2">Delete</th>
                  <th className="border px-2">View</th>
                  <th className="border px-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {permissions.map((row, index) => (
                  <tr key={index} className="text-center">
                    <td className="border px-2">
                      <InputField
                        type="select"
                        options={isMenuIDSData}
                        value={row.menuId}
                        onChange={(val) => handleChange(index, "menuId", val)}
                        placeholder="Select Menu"
                      />
                    </td>
                    {["insert", "update", "delete", "view"].map((perm) => (
                      <td className="border px-2" key={perm}>
                        <InputField
                          type="checkbox"
                          checked={row[perm]}
                          onChange={() => handleChange(index, perm, !row[perm])}
                        />
                      </td>
                    ))}
                    <td className="border px-2">
                      <Button
                        onClick={() => handleRemoveRow(index)}
                        icon={FaMinus}
                        iconColor="text-danger"
                      />{" "}
                      <Button
                        onClick={handleAddRow}
                        icon={FaPlus}
                        iconColor="text-primary"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-end mt-4 gap-3">
              <Button
                text="Cancel"
                className="bg-gray-100 hover:bg-gray-200 text-primary font-semibold text-md rounded-md p-2"
                iconSpacing="pr-1"
                borderColor="border border-gray-300"
                icon={IoMdClose}
                iconSize="w-4 h-4"
                onClick={onCancel}
              />

              <Button
                text={isEditing ? "Update " : " Save "}
                className="bg-orange text-black font-semibold text-md rounded-md p-2"
                iconSpacing="pr-2"
                icon={FaPaperPlane}
                iconSize="w-4 h-4"
                iconColor="text-black"
                onClick={() => {
                  const payload = permissions
                    .filter((p) => p.menuId)
                    .map((p) => ({
                      UserId: Number(localFormData.userId),
                      MenuId: Number(p.menuId),
                      IsInsert: p.insert,
                      IsUpdate: p.update,
                      IsDelete: p.delete,
                      IsView: p.view,
                    }));

                  onSubmit(payload);
                }}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default MenuPermissionForm;
